import React from 'react';
import styled from 'styled-components';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { numberWithCommas } from 'shared/utils/numberUtils';

interface ReportPercentageProps {
  percentage: number | string | undefined;
  backgroundColor?: keyof typeof COLORS;
}

const StyledTrueImpactText = styled(TrueImpactText)<{
  backgroundColor: ReportPercentageProps['backgroundColor'];
}>`
  display: flex;
  text-align: center;
  border-radius: 100px;
  justify-content: center;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? COLORS[backgroundColor] : COLORS.successBackground};
  padding: 6px ${SPACERS.tiny};
`;

const ReportPercentage: React.FC<ReportPercentageProps> = ({
  percentage,
  backgroundColor,
}) => {
  return (
    <StyledTrueImpactText
      variant="body-small"
      backgroundColor={backgroundColor}
    >
      {percentage === undefined
        ? 'Not applicable'
        : `${numberWithCommas(percentage)}%`}
    </StyledTrueImpactText>
  );
};

export default ReportPercentage;
